import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Receipt from '../../../../../assets/images/module/general/ReceiptDummy.png';
import { Row, Col, Form, OverlayTrigger } from 'react-bootstrap';
import CustomModal from '.';
import { showNotification } from '@mantine/notifications';
import ColorButton from '../Buttons/ColorButton';
import CopyIcon from '../../../SVGs/copyIcon';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import RedCross from '../../../../../assets/images/module/general/RedCross.svg';
import { Checkbox, Grid, Group, Stack, TextInput, Tooltip } from '@mantine/core';
import EmptyStateContainer from '../EmptyStateContainer/EmptyStateContainer';
import TenantIcon from '../../../../../assets/images/module/general/TenantIcon.svg';
import TenantIconBlue from '../../../../../assets/images/module/general/TenantIconBlue.svg';
import RightArrowPartner from '../../../../../assets/images/module/general/RightArrowPartner.svg';
import { NumericFormat } from 'react-number-format';
import CardSelection from '../CardSelection/CardSelection';
import BankBlue from '../../../../../assets/images/module/general/Bank.svg';
import Bank from '../../../../../assets/images/module/general/BankGrey.svg';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Autoload from '../../../../Autoload';
import { isPremiumTier } from '../../../../../helpers/subscriptionFeatureAccess';
import accounting from 'accounting';
import TruncatedTextHandler from '../../../../../components/TruncatedTextHandler';
import GeneralDialogueBoxModal from './GeneralDialogueBoxModal';
import { connect } from 'react-redux';

const MOBILE_SIZE = 992;
const TABLET_SIZE = 1200;

export class SelectAccountsForBankConnectionModal extends Component {
    state = {
    isMobile: window.innerWidth <= MOBILE_SIZE,
    isTablet: window.innerWidth <= TABLET_SIZE,
    hover1: false,
    hover2: false,
    selectedType: null,
    accounts: [
        {
            id: 0,
            iban: 'xxxx-xxxx-xxxx-xxxx-xxxx',
            firstName: 'Jhon',
            lastName: 'Doe',
            accountBalance: 2000
        },
        {
            id: 1,
            iban: 'xxxx-xxxx-xxxx-xxxx-xxxx',
            firstName: 'Mr.X',
            lastName: 'XX',
            accountBalance: 2300
        },
        {
            id: 2,
            iban: 'xxxx-xxxx-xxxx-xxxx-xxxx',
            firstName: 'Mr.Y',
            lastName: 'YY',
            accountBalance: 200
        },
    ],
    selectedAccounts: [],
    openPropertyBoundDialogueModal: false,
    openBankAccountRemovalConfirmationDialogueModal: false,
    selectedBankAccountForDeletion: null,
    boundProperties: [],
    bankAccounts: []
    };
    
    constructor(props) {
        super(props);
    }

    componentDidMount(){
        const {bankConnectionData, bankAccounts} = this.props;
        let {selectedAccounts} = this.state;

        selectedAccounts= bankAccounts.filter((account)=> bankConnectionData.bankAccounts.find((bankAccount)=> bankAccount.id === account.id) !== undefined);
        this.setBankAccounts(bankAccounts);
    }

    componentDidUpdate(prevProps){
        const {bankAccounts} = this.props;
        if(prevProps.bankAccounts.filter((prevBankAccount)=> bankAccounts.find((bankAccount)=> bankAccount.id === prevBankAccount.id) === undefined).length > 0){
            this.setBankAccounts(bankAccounts);
        }
    }

    setBankAccounts=(bankAccounts)=>{
        let refreshBanksAccounts = bankAccounts.map((bankAccount)=> ({...bankAccount, boundProperties: []}));
        this.setState({bankAccounts: refreshBanksAccounts}, ()=> bankAccounts.forEach((bankAccount) => {
            this.checkAssociationWithAnyOtherProperty(bankAccount.id);  
        }));
    }

    handleMouseEnter=(type)=>{
        this.setState({[type]: true});
    }

    handleMouseLeave=(type)=>{
        this.setState({[type]: false});
    }

    renderTableHead=()=>{
        const {bankAccounts, accountData} = this.props;
        const {selectedAccounts, accounts} = this.state;

        return(
        <TableHead>
            <TableRow>
                <TableCell className='banks-table-header' style={{maxWidth: '30px', paddingRight: 0}}>
                    <Checkbox
                    checked={bankAccounts.length === selectedAccounts.length}
                    indeterminate={selectedAccounts.length > 0 && bankAccounts.length !== selectedAccounts.length}
                    classNames={{input: 'tenants-list-checkbox-rental-income-input', inner: 'tenants-list-checkbox-rental-income-inner'}}
                    styles={{ 
                        input: {
                            cursor: 'pointer'
                        }
                    }}
                    onChange={()=> bankAccounts.length === selectedAccounts.length ? this.setState({selectedAccounts: []}) : this.setState({selectedAccounts: bankAccounts})}
                    />
                </TableCell>
                <TableCell className='banks-table-header'>Kontoinhaber</TableCell>
                <TableCell className='banks-table-header'>IBAN</TableCell>
                <TableCell className='banks-table-header'>Art</TableCell>
                <TableCell className='banks-table-header' style={{textAlign: 'right'}}>Saldo</TableCell>
                <TableCell className='banks-table-header'><span className='tooltips remove-bank-account-from-bank-connection'>Entfernen</span></TableCell>
            </TableRow>
        </TableHead>
        )
    }

    getBankType=(type)=>{
        switch (type) {
          case 'Checking':
            return 'Girokonto';
          case 'Savings':
            return 'Sparkonto';
          case 'CreditCard':
            return 'Kreditkarte';
          case 'Security':
            return 'Bürgschaft';
          case 'Loan':
            return 'Darlehen';
          case 'Membership':
            return 'Mitgliedschaft';
          case 'Bausparen':
            return 'Bausparkonto';
          default:
            return type;
        }
      }

    handleCheckBoxSelection=(disableRow, account)=>{
        const {currentSubscription, buyPremiumModalOpen} = this.props;
        const {selectedAccounts} = this.state;

        if(disableRow === false){
            if(selectedAccounts.find((selectedAccount)=> selectedAccount.id === account.id) !== undefined){
                this.setState({selectedAccounts: selectedAccounts.filter((selectedAccount)=> selectedAccount.id !== account.id)});
            }else if(isPremiumTier(currentSubscription) && selectedAccounts.length > 0){
                buyPremiumModalOpen();
            }else{
                this.setState({selectedAccounts: [...selectedAccounts, account]});
            }
        }
    }

    renderTableBody=()=>{
        const {currentSubscription, buyPremiumModalOpen, bankConnectionData, accountData} = this.props;
        const {accounts, selectedAccounts, bankAccounts} = this.state;

        return(
            <TableBody>
                {bankAccounts
                .map((account)=>{
                let accountAlreadyExistInProperty = bankConnectionData.bankAccounts.find((bankAccount)=> bankAccount.id === account.id) !== undefined;
                let disableRow= (accountAlreadyExistInProperty || account?.boundProperties?.length > 0);
                return (<TableRow 
                    className={`bank-account-cards ${disableRow ? 'banks-table-row-disabled' : 'banks-table-row'} ${selectedAccounts.find((selectedAccount)=> selectedAccount.id === account.id) !== undefined && 'banks-table-row-selected'}`}>
                        
                        <TableCell className='banks-table-cell' style={{maxWidth: '30px', paddingRight: 0, display: 'flex'}} onClick={()=> this.handleCheckBoxSelection(disableRow, account)}>
                            <Tooltip styles={{root: {width: '100%'}}} disabled={disableRow === false} zIndex={99999} label={'Dieses Konto wird bereits in hellohousing verwendet (Immobilie:'+account.boundProperties.map((boundProperty)=> ` ${boundProperty?.name}`)+').'}>
                                <Checkbox
                                checked={selectedAccounts.find((selectedAccount)=> selectedAccount.id === account.id) !== undefined}
                                classNames={{input: 'tenants-list-checkbox-rental-income-input', inner: 'tenants-list-checkbox-rental-income-inner'}}
                                styles={{ 
                                    input: {
                                        cursor: 'pointer'
                                    }
                                }}
                                disabled={accountAlreadyExistInProperty}
                                onChange={()=> selectedAccounts.find((selectedAccount)=> selectedAccount.id === account.id) !== undefined ? this.setState({selectedAccounts: selectedAccounts.filter((selectedAccount)=> selectedAccount.id !== account.id)}) : this.setState({selectedAccounts: [...selectedAccounts, account]})}
                                />
                            </Tooltip>
                        </TableCell>
                        <TableCell className='banks-table-cell' onClick={()=> this.handleCheckBoxSelection(disableRow, account)}>
                            <Tooltip styles={{root: {width: '100%'}}} disabled={disableRow === false} zIndex={99999} label={'Dieses Konto wird bereits in hellohousing verwendet (Immobilie:'+account.boundProperties.map((boundProperty)=> ` ${boundProperty?.name}`)+').'}>
                                <span>{account.accountHolderName}</span>
                            </Tooltip>
                        </TableCell>
                        <TableCell className='font-weight-bold' onClick={()=> this.handleCheckBoxSelection(disableRow, account)}>
                            <Tooltip styles={{root: {width: '100%'}}} disabled={disableRow === false} zIndex={99999} label={'Dieses Konto wird bereits in hellohousing verwendet (Immobilie:'+account.boundProperties.map((boundProperty)=> ` ${boundProperty?.name}`)+').'}>
                                <span>{account.iban}</span>
                            </Tooltip>
                        </TableCell>
                        <TableCell style={{fontWeight: '400'}} onClick={()=> this.handleCheckBoxSelection(disableRow, account)}>
                            <Tooltip styles={{root: {width: '100%'}}} disabled={disableRow === false} zIndex={99999} label={'Dieses Konto wird bereits in hellohousing verwendet (Immobilie:'+account.boundProperties.map((boundProperty)=> ` ${boundProperty?.name}`)+').'}>
                                <span>{this.getBankType(account.accountType)}</span>
                            </Tooltip>
                        </TableCell>
                        <TableCell style={{textAlign: 'right', fontWeight: '400', whiteSpace: 'nowrap'}} onClick={()=> this.handleCheckBoxSelection(disableRow, account)}>
                            <Tooltip styles={{root: {width: '100%'}}} disabled={disableRow === false} zIndex={99999} label={'Dieses Konto wird bereits in hellohousing verwendet (Immobilie:'+account.boundProperties.map((boundProperty)=> ` ${boundProperty?.name}`)+').'}>
                                <span>{accounting.formatMoney(account.balance, '€', 2, '.', ',', '%v %s')}</span>
                            </Tooltip>
                        </TableCell>
                        <TableCell>
                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                {!disableRow && <button onClick={()=> account.boundProperties.length > 0 ? this.setState({openPropertyBoundDialogueModal: true, boundProperties: account.boundProperties}) : this.setState({openBankAccountRemovalConfirmationDialogueModal: true, selectedBankAccountForDeletion: account.id})} type="button" className="close delete-cost-position" aria-label="Close"><span aria-hidden="true">×</span></button>}
                            </div>
                        </TableCell>
                    </TableRow>);
                })}
            </TableBody>
        )
    }

    postBankAccountProperties=()=>{
        const {selectedAccounts} = this.state;
        const {bankConnectionData} = this.props;
        const filteredSelectedAccounts = selectedAccounts.filter((selectedAccount)=> bankConnectionData.bankAccounts.find((bankAccount)=> bankAccount.id === selectedAccount.id) === undefined);
        
        filteredSelectedAccounts.map((selectedAccount, index)=> 
        Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.finance_api_base_url + 'bankAccountProperties',
            'POST',
            {
                bankAccountId: selectedAccount.id,
                propertyId: this.props.propertySelected.id
            },
            null,
            false,
            true,
            false,
            this,
            'handlePostBankAccountProperties',
            {eol: filteredSelectedAccounts.length === (index + 1)},
            false,
            '',
            {
            // 'Content-Type': 'application/json',
            Authorization: Autoload.Utils.getAuthToken(),
            }
        ));
    }

    handlePostBankAccountProperties(response){
        const {selectedAccounts} = this.state;
        if(response.other.eol){
            if(response.status && response.statuscode === 200){
                showNotification({
                    message: selectedAccounts.length > 1 ? 'Bankkonten erfolgreich hinzugefügt.' : 'Bankkonto erfolgreich hinzugefügt.',
                    icon: <img src={GreenTick} alt='green-tick'/>,
                    id: 'bankAccountsAdded'
                });
            }
            this.props.getBankAccountsByPropertyId();
        }

        if(response.statuscode !== 200){
            showNotification({
              message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
              icon: <img src={RedCross} alt='red-cross'/>,
              id: 'PostBankAccountPropertiesError'
            });
        }
    }

    checkAssociationWithAnyOtherProperty=(bankAccountId)=>{
        Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.finance_api_base_url + `bankAccountProperties/bankAccount/${bankAccountId}`,
            'GET',
            null,
            null,
            false,
            true,
            false,
            this,
            'handleCheckAssociationWithAnyOtherProperty',
            {bankAccountId},
            false,
            '',
            {
            // 'Content-Type': 'application/json',
            Authorization: Autoload.Utils.getAuthToken(),
            }
        );
    }

    handleCheckAssociationWithAnyOtherProperty(response){
        if(response.status && response.statuscode === 200 && response.result?.length > 0){
            let {bankAccounts} = this.state;
            bankAccounts = bankAccounts.map((bankAccount)=> {
                if(bankAccount.id === response.other.bankAccountId){
                    let boundProperties = this.props.allProperties.filter((property)=> response?.result.find((res)=> res?.propertyId === property.id) !== undefined);
                    bankAccount.boundProperties = boundProperties;
                }
                return bankAccount;
            });
            
            this.setState({bankAccounts}); //openPropertyBoundDialogueModal: true, 
        }
        // else{
        //     this.setState({openBankAccountRemovalConfirmationDialogueModal: true, selectedBankAccountForDeletion: response.other.bankAccountId});
        // }
    }
    
    deleteBankAccountFromBankConnection=(bankAccountId)=>{
        if(bankAccountId){
            Autoload.HttpRequestAxios.HttpRequest(
                Autoload.Setting.finance_api_base_url + 'BankAccounts/'+bankAccountId,
                'DELETE',
                null,
                null,
                false,
                true,
                false,
                this,
                'handleDeleteBankAccountFromBankConnection',
                null,
                false,
                '',
                {
                // 'Content-Type': 'application/json',
                Authorization: Autoload.Utils.getAuthToken(),
                }
            );
        }
    }

    handleDeleteBankAccountFromBankConnection(response){
        if(response.status && response.statuscode === 200){
            setTimeout(() => {
                this.setState({selectedBankAccountForDeletion: null, openBankAccountRemovalConfirmationDialogueModal: false}, ()=> this.props.getBankAccountByBankConnectionId());    
            }, 1000);
        }
    }
    
    render() {
    const { open, toggle, className, propertySelected, openAddBankModal, updateBankConnectionImportNewAccounts, bankConnectionData, allProperties } = this.props;
    const { selectedAccounts, isMobile, openPropertyBoundDialogueModal, openBankAccountRemovalConfirmationDialogueModal, selectedBankAccountForDeletion, boundProperties, bankAccounts } = this.state;

    console.log('bankAccounts:  ', bankAccounts);
    return (
        <CustomModal
        heading={'Konten auswählen'}
        headingClassName={'update-received-rent-modal-heading'}
        open={open}
        toggle={() => {
            toggle();
        }}
        className={`${className}`}
        style={{minWidth: isMobile ? 'auto' : '750px'}}
        // style={{maxWidth: '450px'}}
        >
        <Stack>
            <Stack>
                {bankAccounts.length > 0 &&
                <Group>
                    <span style={{fontFamily: 'Inter, sans-serif', fontWeight: '300'}}>Bitte wählen Sie die Bankkonten, die Sie zur Immobilie <span style={{fontWeight: 'bold'}}>{propertySelected?.name}</span> hinzufügen wollen.</span>
                </Group>}
                {bankAccounts.length > 0 ?
                <Stack gap={0}>
                    <TableContainer style={{maxHeight: '380px'}}>
                        <Table style={{borderCollapse: 'separate', borderSpacing: '0px 8px'}}>
                            {this.renderTableHead()}
                            {this.renderTableBody()}
                        </Table>
                    </TableContainer>
                    <Group wrap="nowrap" gap={0}>
                        <Group wrap="nowrap" style={{fontSize: '12px', fontWeight: '400', color: '#5555FF', cursor: 'pointer', margin: '5px 0px'}} gap={5} onClick={()=> updateBankConnectionImportNewAccounts()}>Weitere Konten dieser Bankverbindung für die Verwendung in hellohousing freigeben. <img src={RightArrowPartner} style={{marginTop: '2px', width: '12px'}}/></Group>
                    </Group>
                </Stack>
                :
                <Group justify='center' align='center'>
                    <EmptyStateContainer
                    heading={'Keine Bankkonten gefunden.'}
                    subheading={'Erstellen Sie eine neue Bankverbindung, um weitere Konten hinzuzufügen.'}
                    showBtn={true}
                    btnText={'Neue Bankverbindung erstellen'}
                    btnHandler={()=> openAddBankModal()}
                    icon={Bank}
                    styleMainContainer={{margin: '20px 0px'}}
                    rootStyle={{width: '100%'}}
                    />
                </Group>}
            </Stack>
            <Group justify="space-between">
                <div>
                    <ColorButton
                    text={'Abbrechen'}
                    className='gray-btn'
                    onClick={()=> toggle()}
                    />
                </div>
                <div>
                    <ColorButton
                    text={'Hinzufügen'}
                    className='purple-btn'
                    onClick={()=> this.postBankAccountProperties()}
                    disabled={selectedAccounts.filter((selectedAccount)=> bankConnectionData.bankAccounts.find((bankAccount)=> bankAccount.id === selectedAccount.id) === undefined).length === 0}
                    />
                </div>
            </Group>
        </Stack>
        {openPropertyBoundDialogueModal &&
        <GeneralDialogueBoxModal
        open={openPropertyBoundDialogueModal}
        heading={'Konto wird verwendet'}
        hideNext={true}
        mainText={
        <Stack>
            <span>Das Konto wird bereits in folgenden Immobilien verwendet:</span>
            <span>{boundProperties.length > 0 ? boundProperties.map((boundProperty, index)=> <span className='bound-property-option' onClick={()=> document.getElementById(`select-property-${boundProperty?.id}`)?.click()}>{`${index > 0 ? ', ' : ''}${boundProperty.name}`}</span>) : ''}</span>
            <span>Das Konto kann aus der Auswahlliste entfernt werden, solange es verwendet wird.</span>
        </Stack>}
        mainTextStyling={{margin: 0}}
        closeButtonText={'Schließen'}
        closeButtonClassname={'purple-btn'}
        buttonsPosition={'right'}
        toggle={()=> this.setState({openPropertyBoundDialogueModal: false, boundProperties: []})}
        />}

        {openBankAccountRemovalConfirmationDialogueModal &&
        <GeneralDialogueBoxModal
        open={openBankAccountRemovalConfirmationDialogueModal}
        heading={'Konto aus Auswahliste entfernen'}
        mainText={'Sind Sie sicher, dass Sie das Konto aus der Liste der freigegebenen Konten entfernen wollen? Wenn Sie das Konto in Zukunft verwenden wollen, müssen Sie sich erneut bei Ihrer Bank autorisieren.'}
        mainTextStyling={{margin: 0}}
        nextButtonText={'Konto entfernen'}
        nextButtonClassname={'red-btn'}
        toggle={()=> this.setState({openBankAccountRemovalConfirmationDialogueModal: false})}
        next={()=> {
            this.deleteBankAccountFromBankConnection(selectedBankAccountForDeletion);
            // if(bankAccounts.length === 1){
            //     this.props.deleteBankConnection(bankAccounts[0].bankConnectionId);
            //     toggle();
            // }else{
            //     this.deleteBankAccountFromBankConnection(selectedBankAccountForDeletion);
            // }
        }}
        />}
        </CustomModal>
    );
    }
}

const mapStateToProps = (state) => {
    return {
      propertySelected: state.generalReducer.property,
      allProperties: state.generalReducer.allProperties,
      accountData: state.generalReducer.accountData
    };
  };

export default connect(mapStateToProps)(SelectAccountsForBankConnectionModal);
